(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function applyFeaturedVariantCards(root) {
    const variantCards = root.querySelectorAll('.product-grid__item[data-variant-id][data-variant-url]');

    variantCards.forEach((card) => {
      const variantUrl = card.dataset.variantUrl;
      const variantImageUrl = card.dataset.variantImageUrl;

      if (variantUrl) {
        card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
          link.setAttribute('href', variantUrl);
        });
      }

      if (variantImageUrl) {
        card.querySelectorAll('img').forEach((img) => {
          img.setAttribute('src', variantImageUrl);
          img.removeAttribute('srcset');
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-sizes');
        });
      }
    });
  }

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const resultsList = document.querySelector('results-list');
    if (!resultsList) return;

    applyFeaturedVariantCards(resultsList);

    const variantCardObserver = new MutationObserver(() => {
      applyFeaturedVariantCards(resultsList);
    });

    variantCardObserver.observe(resultsList, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-support-nk"] && !Shopify.designMode) return;
  try {
    
  class SupportFaqTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-faq-tab]')];
      this.panels = [...this.querySelectorAll('[data-faq-panel]')];
      this.tabs.forEach((tab) => tab.addEventListener('click', this.handleTabClick));
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => tab.removeEventListener('click', this.handleTabClick));
    }

    handleTabClick = (event) => {
      const selectedKey = event.currentTarget.dataset.faqTab;

      this.tabs.forEach((tab) => {
        const isSelected = tab.dataset.faqTab === selectedKey;
        tab.classList.toggle('is-active', isSelected);
        tab.setAttribute('aria-expanded', String(isSelected));
      });

      this.panels.forEach((panel) => {
        const isSelected = panel.dataset.faqPanel === selectedKey;
        panel.hidden = !isSelected;
        if (!isSelected) panel.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
      });
    };
  }

  if (!customElements.get('support-faq-tabs')) {
    customElements.define('support-faq-tabs', SupportFaqTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
